/* eslint-disable */

export const getAllSourcesConstants = {
    GET_SOURCES_REQUEST: 'GET_SOURCES_REQUEST',
    GET_SOURCES_SUCCESS: 'GET_SOURCES_SUCCESS',
    GET_SOURCES_FAILURE: 'GET_SOURCES_FAILURE',
};
